/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import IntegrationsDetailsPanel from './layout';
import {
  isInherited,
  userHasUpdatePermission,
  isEntityFetching,
  itemApiPending,
  userHasPermissions,
  getSelectedEntity,
  getSelectedEntityId,
} from '../../../redux/modules/entities/selectors';
import {
  removeTwilioGlobalDialParam,
  removeEcgGlobalDialParam,
  setCurrentSubEntity,
  setSelectedSubEntityId,
  updateTwilioGlobalDialParam,
  updateEcgGlobalDialParam,
} from '../../../redux/modules/entities';
import {
  getSelectedIntegrationType,
  selectGlobalDialParams,
  selectIntegrationListeners,
} from '../../../redux/modules/entities/integrations/selectors';
import { getCurrentFormValueByFieldName } from '../../../redux/modules/form/selectors';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';

export function mapStateToProps(state) {
  const formType = getCurrentFormValueByFieldName(state, 'type');
  const selectedEntity = getSelectedEntity(state);
  const selectedType = selectedEntity && selectedEntity.get ? selectedEntity.get('type') : undefined;
  const normalizedFormType =
    typeof formType === 'string'
      ? formType
      : formType && typeof formType.get === 'function'
        ? formType.get('value') || formType.get('type')
        : formType && typeof formType === 'object'
          ? formType.value || formType.type
          : undefined;

  const formProperties = getCurrentFormValueByFieldName(state, 'properties');
  const selectedProperties = selectedEntity && selectedEntity.get ? selectedEntity.get('properties') : undefined;
  const mergedProperties = selectedProperties && formProperties
    ? (typeof selectedProperties.merge === 'function'
      ? selectedProperties.merge(formProperties)
      : { ...selectedProperties, ...formProperties })
    : (formProperties || selectedProperties);

  return {
    inherited: isInherited(state),
    userHasUpdatePermission: userHasUpdatePermission(state),
    integrationsFetching: isEntityFetching(state, 'integrations'),
    listenersItems: selectIntegrationListeners(state),
    listenersFields: entitiesMetaData.integrations.membersTableFields.listeners,
    selectedEntityId: getSelectedEntityId(state),
    integrationType: normalizedFormType || selectedType,
    integrationProperties: mergedProperties,
    itemApiPending: itemApiPending(state),
    globalDialParamsItems: selectGlobalDialParams(state),
    selectedIntegrationType: getSelectedIntegrationType(state),
    sidePanelUpdatePermissions: {
      twilioGlobalDialParams: userHasPermissions(state, [
        'TWILIO_GLOBAL_DIAL_PARAMS_MANAGE',
        'PLATFORM_TWILIO_GLOBAL_DIAL_PARAMS_MANAGE',
      ]),
      ecgGlobalDialParams: userHasPermissions(state, [
        'ECG_GLOBAL_DIAL_PARAMS_MANAGE',
        'PLATFORM_ECG_GLOBAL_DIAL_PARAMS_MANAGE',
      ]),
    },
  };
}

export const actions = {
  removeTwilioGlobalDialParam,
  removeEcgGlobalDialParam,
  setCurrentSubEntity,
  setSelectedSubEntityId,
  updateTwilioGlobalDialParam,
  updateEcgGlobalDialParam,
};

export default connect(mapStateToProps, actions)(IntegrationsDetailsPanel);
